import { render, staticRenderFns } from "./ProductCardSizes.vue?vue&type=template&id=6f63b0bb&"
import script from "./ProductCardSizes.vue?vue&type=script&lang=js&"
export * from "./ProductCardSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f63b0bb')) {
      api.createRecord('6f63b0bb', component.options)
    } else {
      api.reload('6f63b0bb', component.options)
    }
    module.hot.accept("./ProductCardSizes.vue?vue&type=template&id=6f63b0bb&", function () {
      api.rerender('6f63b0bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardSizes.vue"
export default component.exports